var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topbar"},[_c('enterprises-header')],1),_c('Search',{ref:"search",attrs:{"old-search":true,"search-type":"enterprises"},on:{"invite":_vm.invite}}),_c('add-connection',{ref:"addEnterprise"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }